import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import Axios from "axios";
import { BookingScheduleInterface } from "../../../features/Booking-Form/typings/booking.types";
import { fetchVisitorBookingSchedules, VisitorBookingsMode } from "./visitor-booking-schedules.api";

export function useRemoteFetchVisitorBookingSchedules(mode: VisitorBookingsMode, enabled: boolean) {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useQuery<BookingScheduleInterface[], Error>(
    ["visitorBookingSchedules", mode],
    async () => {
      const result = await fetchVisitorBookingSchedules(mode);
      return result.data;
    },
    {
      enabled,
      refetchOnWindowFocus: false,
      onError: err => {
        const message = Axios.isAxiosError(err)
          ? err.response?.status === 404
            ? t("_visitorBookings_fetchNotFound")
            : t("_visitorBookings_fetchFailed")
          : t("_visitorBookings_fetchFailed");
        enqueueSnackbar(message, { variant: "error" });
      }
    }
  );
}
